module.exports = __webpack_public_path__ + "static/img/logo12.0b31d27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo12.png
// module id = dRHj
// module chunks = 1